import { Subscription } from './Subscription';

export const PORTAL_SUBSCRIPTION_PLATFORMS = ['apple', 'google', 'stripe', 'admin'] as const;
export type PortalSubscriptionPlatform = (typeof PORTAL_SUBSCRIPTION_PLATFORMS)[number];

export const PORTAL_STRIPE_KINDS = ['ajassa', 'rv'] as const;
export type PortalStripeKind = (typeof PORTAL_STRIPE_KINDS)[number];

export type PortalUserFilters = {
  platform?: PortalSubscriptionPlatform[];
  stripeKind?: PortalStripeKind | '';
  codeOnly?: boolean;
  activeOnly?: boolean;
  missingEndDate?: boolean;
  marketing?: boolean;
  search?: string;
  limit?: number;
  offset?: number;
};

export type PortalUserStats = {
  totalUsers: number;
  activeSubscriptions: number;
  appleSubscriptions: number;
  googleSubscriptions: number;
  stripeSubscriptions: number;
  codeSubscriptions: number; // active code-based subscriptions (paymentType=2)
  adminSubscriptions: number; // NEW: all active admin subs (regardless of paid)
  adminAddedSubscriptions: number;
};

export type PortalUsersPagination = {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
};

export type PortalUsersResponse = {
  data: User[];
  pagination: PortalUsersPagination;
};

export type User = {
  id: number | null;
  firstname: string;
  lastname: string;
  email: string;
  emailVerified: boolean;
  churchId?: string | null;
  phone?: string;
  address?: string;
  postalcode?: string;
  city?: string;
  country?: string;
  admin: boolean;
  publisher: boolean;
  creator: boolean;
  employee: boolean;
  portal?: boolean;
  subscriber: boolean;
  tester: boolean;
  customerId?: string;
  permission?: boolean;
  marketing?: boolean;
  newsletter?: boolean;
  empNewsletter?: boolean;
  subscriptions?: Subscription[];
  communities?: Community[];
  communityIds?: number[];
  subscriptionTypeId?: number;
  subscriptionMonths?: number;
  deletedAt?: string;
  nextUsageResetDate?: string;

  // Portal users (computed fields from backend; do not derive client-side)
  activeSubscriptionPlatform?: string | null;
  activeSubscriptionPaymentType?: number | null;
  activeSubscriptionTypeName?: string | null;
  activeSubscriptionId?: number | null;
  latestSubscriptionPlatform?: string | null;
  latestSubscriptionPaymentType?: number | null;
  latestSubscriptionTypeName?: string | null;
  latestSubscriptionId?: number | null;
};

export type LoginAuth = {
  email: string;
  password: string;
};

export type Community = {
  id?: number;
  community: string;
  createdAt?: string;
  updatedAt?: string;
};

export type Products = {
  id: string;
  name: string;
  description?: string;
  price_month: number;
  price_month_id: string;
  price_year: number;
  price_year_id: string;
  active: boolean;
};
